import {
  LOAD_PREFERENCES_REQUEST,
  LOAD_PREFERENCES_SUCCESS,
  LOAD_PREFERENCES_FAIL,
  SAVE_PREFERENCES_REQUEST,
  SAVE_PREFERENCES_SUCCESS,
  SAVE_PREFERENCES_FAIL,
} from '../actions/preferences';

const initialState = {
  preferences: null,
  loading: false,
  error: null,
};

const preferencesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PREFERENCES_REQUEST:
    case SAVE_PREFERENCES_REQUEST:
      return { ...state, loading: true };

    case LOAD_PREFERENCES_SUCCESS:
    case SAVE_PREFERENCES_SUCCESS:
      return {
        ...state,
        loading: false,
        preferences: action.payload,
        error: null,
      };

    case LOAD_PREFERENCES_FAIL:
    case SAVE_PREFERENCES_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default preferencesReducer;
